export const dateFormats = {
  dayMonthFormat: 'dd MMMM YYYY',
  dayMonthPointFormat: 'dd.MM.yyyy',
  monthDayFormat: 'MM dd YYYY',
  dayMonthHourFormat: 'dd.MM.yyyy - HH:mm',
};
